import {
	Button,
	Stack,
	type SxProps,
	type Theme,
	Typography,
} from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import type { LeaveConfirmation } from "web_myplann/Shared/Hooks/useLeaveConfirmation";

const DISCARD_BUTTON_SX: SxProps<Theme> = {
	color: (theme) => theme.palette.blue[600],
};

type UnsavedChangesDrawerProps = LeaveConfirmation & {
	loading?: boolean;
};

export const UnsavedChangesDrawer = ({
	open,
	loading,
	onSave,
	onDiscard,
	onClose,
}: UnsavedChangesDrawerProps) => {
	const { t } = useResource();

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={loading ? undefined : onClose}
			title={t(Resources.Portfolio.EditPortfolio.UnsavedChanges.title)}
			grabber
		>
			<Stack px={2} pb={2} gap={2}>
				<Typography variant="body2">
					{t(Resources.Portfolio.EditPortfolio.UnsavedChanges.description)}
				</Typography>
				<Stack gap={1}>
					<Button variant="primary" loading={loading} onClick={onSave}>
						{t(Resources.Portfolio.EditPortfolio.submit)}
					</Button>
					<Button
						variant="ghost"
						sx={DISCARD_BUTTON_SX}
						disabled={loading}
						onClick={onDiscard}
					>
						{t(Resources.Portfolio.EditPortfolio.UnsavedChanges.discard)}
					</Button>
				</Stack>
			</Stack>
		</MyPlannDrawer>
	);
};
